import { useFormikContext } from "formik";
import {
  DisplayFormErrors,
  InputField,
  VerticalForm,
} from "melco-shared-logic";
import { Col, Row, DesignTokens, FormSection, FormRow } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { EditProfileConfirmButton } from "../EditProfileConfirmButton";
import { useEffect, useState } from "react";
import AntdForm from "antd/es/form";
import { StatesSelect } from "../../common/StatesSelect";
import { GenderSelect } from "../../common/GenderSelect";
import { useRolesContext } from "../../../hooks/roles/useRolesContext";
import RegisterUserCountrySelect from "../../common/RegisterUserCountrySelect";

const { spacings } = DesignTokens;

const StyledFormItem = styled(AntdForm.Item)`
  margin-bottom: ${spacings.middle}px;

  .ant-form-item-label {
    padding-bottom: ${spacings.xsmall}px;
  }
`;

type DisplayEditUserFormProps = {
  EditFlag: boolean;
};

export const DisplayEditUserForm: React.FC<DisplayEditUserFormProps> = ({
  EditFlag,
}) => {
  const { t } = useTranslation();
  const { setFieldValue, values } = useFormikContext();
  const [formFields, setFields] = useState<any>(values);
  const { roles } = useRolesContext();
  const parentUserId = formFields?.parent_user_id ?? "";
  const subUserFlag = parentUserId != "" ? true : false;

  useEffect(() => {
    setFields(values);
  }, [values]);

  return (
    <>
      <div>
        <VerticalForm>
          <DisplayFormErrors />

          <FormSection title={t("users.profiledetails.internal_information")}>
            <Row gutter={[spacings.middle, 0]}>
              <Col xs={24} md={12}>
                <InputField
                  name="id"
                  label={t("users.profiledetails.id")}
                  readOnly={true}
                  disabled={true}
                />
              </Col>
              <Col xs={24} md={12}>
                <InputField
                  name="created_date"
                  label={t("users.profiledetails.created_date")}
                  readOnly={true}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row gutter={[spacings.middle, 0]}>
              <Col xs={24} md={12}>
                {!EditFlag && <InputField

                  name="melco_customer_id"
                  label={t("users.profiledetails.melco_customer_id")}
                  readOnly={!EditFlag}
                  disabled={!EditFlag}
                />
                }
                {
                  EditFlag && <InputField

                    name="melco_customer_id"
                    label={t("users.profiledetails.melco_customer_id")}
                    readOnly={roles?.USERS_EDIT_MELCOCUSTOMERID !== true}
                    disabled={roles?.USERS_EDIT_MELCOCUSTOMERID !== true}
                  />
                }
              </Col>
            </Row>
          </FormSection>
          <FormSection title={t("users.profiledetails.personal_information")}>
            <StyledFormItem>
              <span> {t("users.profiledetails.gender")}</span>

              <GenderSelect
                value={formFields.gender_code?.toString() ?? undefined}
                name="gender_code"
                //selectedCountry={formFields?.address?.country_code ?? undefined}
                onChange={(value) => {
                  setFieldValue("gender_code", value);
                }}
                //mode={false}
                readOnly={!EditFlag}
                disabled={!EditFlag}
              />
            </StyledFormItem>

            <InputField
              name="first_name"
              label={t("users.profiledetails.first_name")}
              readOnly={!EditFlag}
              disabled={!EditFlag}
            />

            <InputField
              name="last_name"
              label={t("users.profiledetails.last_name")}
              readOnly={!EditFlag}
              disabled={!EditFlag}
            />

            <Row gutter={[spacings.middle, 0]}>
              <Col xs={24} md={12}>
                <InputField
                  name="account_name"
                  label={t("users.profiledetails.account_name")}
                  readOnly={!EditFlag && !subUserFlag}
                  disabled={!EditFlag && !subUserFlag}
                />
              </Col>
              <Col xs={24} md={12}>
                <InputField
                  name="user_name"
                  label={t("users.profiledetails.user_name")}
                  readOnly={true}
                  disabled={true}
                />
              </Col>
            </Row>

            <InputField
              name="company_name"
              label={t("users.profiledetails.company_name")}
              readOnly={!EditFlag}
              disabled={!EditFlag}
            />

            {/* <Row gutter={[spacings.middle, 0]}>
              <Col xs={24} md={12}>
                <InputField
                  name="id"
                  label={t("users.profiledetails.id")}
                  readOnly={true}
                  disabled={true}
                />
              </Col>
              <Col xs={24} md={12}>
                <InputField
                  name="created_date"
                  label={t("users.profiledetails.created_date")}
                  readOnly={true}
                  disabled={true}
                />
              </Col>
            </Row> */}
            {/* <InputField
              name="melco_customer_id"
              label={t("users.profiledetails.melco_customer_id")}
              readOnly={!EditFlag}
              disabled={!EditFlag}
            /> */}
            <Row gutter={[spacings.middle, 0]}>
              <Col xs={24} md={12}>
                <InputField
                  name="phone"
                  label={t("users.profiledetails.phone")}
                  readOnly={!EditFlag}
                  disabled={!EditFlag}
                />
              </Col>
              <Col xs={24} md={12}>
                <InputField
                  name="website"
                  label={t("users.profiledetails.website")}
                  readOnly={!EditFlag}
                  disabled={!EditFlag}
                />
              </Col>
            </Row>
          </FormSection>
          <FormSection title={t("users.profiledetails.address_information")}>
            <InputField
              name="address.street1"
              label={t("users.profiledetails.street1")}
              readOnly={!EditFlag}
              disabled={!EditFlag}
            />

            <InputField
              name="address.street2"
              label={t("users.profiledetails.street2")}
              readOnly={!EditFlag}
              disabled={!EditFlag}
            />

            <InputField
              name="address.postal_code"
              label={t("users.profiledetails.postal_code")}
              // value={UserDetails?.address?.postal_code ?? ""}
              readOnly={!EditFlag}
              disabled={!EditFlag}
            />
            <InputField
              name="address.city"
              label={t("users.profiledetails.city")}
              readOnly={!EditFlag}
              disabled={!EditFlag}
            />
            {/* <InputField
              name="address.country_code"
              label={t("users.profiledetails.country")}
              readOnly={true}
              disabled={true}
            /> */}
            <RegisterUserCountrySelect
              label={t("users.profiledetails.country")}
              name="address.country_code"
              disabled={true}
            />
            <StyledFormItem>
              <span> {t("users.profiledetails.state")}</span>
              <StatesSelect
                value={formFields?.address?.state_code?.toString() ?? undefined}
                name="address.state_code"
                selectedCountry={formFields?.address?.country_code ?? undefined}
                onChange={(value) => {
                  setFieldValue("address.state_code", value);
                }}
                //mode={false}
                readOnly={!EditFlag}
                disabled={!EditFlag}
              />
            </StyledFormItem>
          </FormSection>
          {EditFlag && (
            <FormRow justify="end">
              <EditProfileConfirmButton />
            </FormRow>
          )}
        </VerticalForm>
      </div>
    </>
  );
};
